export default "__VITE_ASSET__9510bd79__"